import { Auth0Provider as Auth0ProviderBase, Auth0ProviderOptions } from '@auth0/auth0-react';
import { ReactNode } from 'react';

import AppSettings from '../constants';

interface Auth0Config extends Auth0ProviderOptions {
    authorizationParams: {
        redirect_uri: string;
        audience: string;
        scope: string;
    };
}

// Generate dynamic redirect URI based on current window location
const getRedirectUri = (): string => {
    const { protocol, host } = window.location;
    return `${protocol}//${host}/app/auth`;
};

const auth0Config: Auth0Config = {
    domain: AppSettings.auth0.domain,
    clientId: AppSettings.auth0.clientId,
    authorizationParams: {
        redirect_uri: getRedirectUri(),
        audience: AppSettings.auth0.audience,
        scope: 'openid profile email offline_access',
    },
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    cookieDomain: AppSettings.auth0.cookieDomain,
};

interface Auth0ProviderProps {
    children: ReactNode;
}

export const Auth0Provider = ({ children }: Auth0ProviderProps) => {
    return <Auth0ProviderBase {...auth0Config}>{children}</Auth0ProviderBase>;
};
